import { ASSIGNMENT_STATUS, ENTITY_TYPE } from "./constants";
import { getSchoolAssignments } from "./getAssignment/getAssignment";
import { updateBatchAssignments } from "./updateBatchAssignments";
import { getDefaultTemplates } from "./getAssignmentTemplate";
import { addAssignment } from "./addAssignment/addAssignment";
import { cleanManifest, insertLetterNamingAndSounds, removeLetterNamingAndSounds } from "./manifest";

export async function getSchoolWindow(schoolId){

  let assignments = await getSchoolAssignments(schoolId);
  return assignments.filter(assignment=>assignment.status === ASSIGNMENT_STATUS.ASSIGNED);
}

export async function unassignSchoolAssignments(schoolId){
  let assignments = await getSchoolAssignments(schoolId);
  if(assignments.length){
    const assignmentIds = assignments.map((assignment)=>assignment.assignmentId);
    if(assignmentIds.length){
      let batchInput = assignmentIds.map((id)=>{
        return {
          entityId: schoolId,
          entityType: ENTITY_TYPE.SCHOOL,
          assignmentId: id,
          status: ASSIGNMENT_STATUS.UNASSIGNED
        }
      });
      await updateBatchAssignments(batchInput);
    }
  }
}

export async function updateSchoolScreeningWindow(schoolId, dateStart, dateEnd, licenseData){
  const requestResults = await Promise.all([unassignSchoolAssignments(schoolId),getDefaultTemplates(schoolId, ENTITY_TYPE.SCHOOL)]);

  // it got the template for each grade, why are we using the 4th template? does it matter which one we take?
  let placeholderTemplate = requestResults[1][3]; 
  placeholderTemplate.manifest = cleanManifest(placeholderTemplate.manifest);

  // if the licenseData has letterNamingAndSoundsConfig, and it has at least one config that is true, then we insert the letterNamingAndSounds activity
  if(licenseData?.letterNamingAndSoundsConfig?.length && licenseData.letterNamingAndSoundsConfig.some((config)=>config)){
    placeholderTemplate.manifest = insertLetterNamingAndSounds(placeholderTemplate.manifest);
  }else if(licenseData?.letterNamingAndSoundsConfig?.length && !licenseData.letterNamingAndSoundsConfig.some((config)=>config)){
    placeholderTemplate.manifest = removeLetterNamingAndSounds(placeholderTemplate.manifest);
  }

  let assignment = {
    assignmentType: "BENCHMARK",
    dateFrom: dateStart,
    dateTo: dateEnd,
    entityId: schoolId,
    entityType: ENTITY_TYPE.SCHOOL,
    manifest: placeholderTemplate.manifest,
    status: ASSIGNMENT_STATUS.ASSIGNED
  }

  let resp = await addAssignment(assignment);
  return resp;
}